// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".input-guidance{font-size:12px;font-style:italic}", "",{"version":3,"sources":["webpack://./src/pages/signupPage.scss"],"names":[],"mappings":"AAAA,gBACE,cAAA,CACA,iBAAA","sourcesContent":[".input-guidance {\n  font-size: 12px;\n  font-style: italic;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
